export default __webpack_public_path__ + "static/media/11-abstract.e91201e6.jpg";